import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ReviewSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const reviews = [
    { image: "WhatsApp Image 2025-03-07 at 4.50.38 PM (1).jpeg"},
    { image: "WhatsApp Image 2025-03-07 at 4.50.38 PM.jpeg"},
    { image: "WhatsApp Image 2025-03-07 at 4.50.38 PM (1).jpeg"},
    { image: "WhatsApp Image 2025-03-07 at 4.50.38 PM.jpeg"},
    { image: "WhatsApp Image 2025-03-07 at 4.50.38 PM (1).jpeg"}
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % reviews.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#f3f4f6] flex flex-col justify-center items-center px-4 py-8 relative" id="contact">
      <div className="w-full max-w-md sm:max-w-lg md:max-w-xl relative">
        <div className="text-center mb-12">
          <h1 className="text-xl sm:text-2xl font-bold text-blue-950">
            Honest {" "}
            <span
            style={{
              background: "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
              padding: "0px 5px",
            }}
          >Reviews About Our
            </span>
            Service
          </h1>
          <p className="text-base text-gray-600">Hear what our customers have to say</p>
        </div>

        <div className="relative w-full h-[250px] sm:h-[350px] md:h-[450px] flex justify-center items-center">
          {reviews.map((review, index) => {
            const isActive = index === activeIndex;
            const isPrev = index === (activeIndex - 1 + reviews.length) % reviews.length;
            const isNext = index === (activeIndex + 1) % reviews.length;

            return (
              <motion.div
                key={index}
                className="absolute w-[180px] sm:w-[240px] md:w-[300px] h-[250px] sm:h-[350px] md:h-[450px] bg-black rounded-xl border-2 border-gray-800 shadow-md overflow-hidden flex flex-col"
                style={{
                  zIndex: isActive ? 10 : isNext || isPrev ? 5 : 1,
                }}
                initial={{ x: isNext ? 80 : isPrev ? -80 : 0, scale: isActive ? 1 : 0.8, opacity: isActive ? 1 : 0.5 }}
                animate={{ x: isActive ? 0 : isNext ? 80 : isPrev ? -80 : 0, scale: isActive ? 1 : 0.8, opacity: isActive ? 1 : 0.5 }}
                transition={{ duration: 0.7 }}
              >
                <img src={review.image} alt={`Review ${index + 1}`} className="w-full h-full object-cover rounded-xl" />
                {isActive && (
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 p-2 text-white text-center">
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Round Elements (Visible Only on Large Screens) */}
      <div className="hidden lg:flex absolute top-[15%] left-[15%] z-20 w-[150px] h-[150px] bg-[#234152] rounded-[15%] flex-col justify-center items-center shadow-lg">
        <h3 className="text-white text-sm font-bold text-center">Overall Satisfaction</h3>
      </div>

      <div className="hidden lg:flex absolute top-[15%] right-[15%] z-20 w-[150px] h-[150px] bg-[#234152] rounded-[15%] flex-col justify-center items-center shadow-lg">
        <h3 className="text-white text-sm font-bold text-center">Essay Quality</h3>
      </div>

      <div className="hidden lg:flex absolute middle-[15%] right-[15%] z-20 w-[100px] h-[100px] bg-[#234152] rounded-full flex-col justify-center items-center shadow-lg">
      <p className='text-white text-[45px] font-bold text-center'>★</p>
      </div>

      <div className="hidden lg:flex absolute middle-[15%] left-[15%] z-20 w-[100px] h-[100px] bg-[#234152] rounded-full flex-col justify-center items-center shadow-lg">
      <p className='text-white text-[45px] font-bold  text-center'>★</p>
      </div>

      <div className="hidden lg:flex absolute bottom-[15%] left-[15%] z-20 w-[150px] h-[150px] bg-[#234152] rounded-[15%] flex-col justify-center items-center shadow-lg">
        <h3 className="text-white text-sm font-bold text-center">Delivery Time</h3>
      </div>

      <div className="hidden lg:flex absolute bottom-[15%] right-[15%] z-20 w-[150px] h-[150px] bg-[#234152] rounded-[15%] flex-col justify-center items-center shadow-lg">
        <h3 className="text-white text-sm font-bold text-center">Plagiarism and Originality</h3>
      </div>
    </div>
  );
};

export default ReviewSection;
